// ═══════════════════════════════════════════════════════════════
// Committee Options — Shared Constant
// Path: src/constants/committees.js
//
// Extracted from DonorDetailView.jsx during modularization.
// Imported by: DonorDetailView, CultivationCommsTab,
//              ClassificationSection (future)
// ═══════════════════════════════════════════════════════════════

export const COMMITTEES = [
  { value: "program", label: "Program" },
  { value: "membership", label: "Membership" },
  { value: "marketing", label: "Marketing" },
  { value: "communications", label: "Communications" },
];
